import { render, staticRenderFns } from "./Waiter.vue?vue&type=template&id=0a3f6f90&scoped=true"
import script from "./Waiter.vue?vue&type=script&lang=js"
export * from "./Waiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f6f90",
  null
  
)

export default component.exports